<template>
<!--    <p class="text-base md:text-lg" :class="[ options.color || '' || 'text-transparent bg-clip-text ' + 'bg-gradient-to-r', 'from-' + options.from, 'to-' + options.to]">-->
    <p class="font-bold text-base md:text-lg" :class="[ options.color || '' || 'text-transparent bg-clip-text ' + 'bg-gradient-to-r',  options.from,  options.to, 'from-' + options.from, 'to-' + options.to]">
        <slot></slot>
    </p>
</template>

<script>
    export default {
        name: 'TitleParagraph',
        props: {
            options: null
        }
    };
</script>

<style lang="scss" scoped></style>
